import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Icon, Text } from '../../index';
import { FLAG_DEFAULT_SIZE, FLAG_VARIANT_ICON, FLAG_VARIANT_LABEL } from './Flag.constants';
import { FlagRoot } from './Flag.styled';
// Component
// -----------------------------------------------------------------------------
const Flag = forwardRef(({ label, size = FLAG_DEFAULT_SIZE, variant, icon }, ref) => {
    return (_jsxs(FlagRoot, { ref: ref, size: size, variant: variant, children: [size === 'm' && !icon && _jsx(Icon, { icon: FLAG_VARIANT_ICON[variant] }), size === 'm' && !!icon && _jsx(Icon, { icon: icon }), _jsx(Text, { className: "flag__text", size: "xs", bold: true, children: label || FLAG_VARIANT_LABEL[variant] })] }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Flag.displayName = 'Flag';
export default Flag;
//# sourceMappingURL=Flag.js.map